<div class="categories-page">
  <div class="page-header">
    <h1>Gestión de Categorías</h1>
    <button mat-raised-button color="primary" (click)="openCategoryDialog()">
      <mat-icon>add</mat-icon>
      Nueva categoría
    </button>
  </div>

  <mat-accordion multi>
    <mat-expansion-panel *ngFor="let category of categories" class="category-panel">
      <mat-expansion-panel-header>
        <mat-panel-title class="category-title">
          <span class="color-chip" [style.background-color]="backgroundStyle(category)"></span>
          <img *ngIf="category.imageUrl" [src]="category.imageUrl" class="category-image" alt="icono" />
          <mat-icon *ngIf="!category.imageUrl">{{ category.iconName || 'category' }}</mat-icon>
          <span class="category-name">{{ category.categoryName }}</span>
        </mat-panel-title>
        <mat-panel-description class="category-description">
          <span class="subcategory-count">{{ category.subcategories?.length || 0 }} subcategorías</span>
          <span class="status-badge" [class.active]="category.active" [class.inactive]="!category.active">
            {{ category.active ? 'Activa' : 'Inactiva' }}
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="category-actions">
        <mat-slide-toggle
          [checked]="category.active"
          (click)="$event.stopPropagation()"
          (change)="toggleCategory(category, $event.checked)">
          Habilitada
        </mat-slide-toggle>
        <span class="spacer"></span>
        <button mat-stroked-button (click)="openCategoryDialog(category)">
          <mat-icon>edit</mat-icon>
          Editar categoría
        </button>
        <button mat-stroked-button color="primary" (click)="openSubcategoryDialog(category)">
          <mat-icon>add</mat-icon>
          Nueva subcategoría
        </button>
      </div>

      <table mat-table [dataSource]="category.subcategories || []" class="subcategories-table"
             *ngIf="category.subcategories?.length; else noSubcategories">

        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef>Icono</th>
          <td mat-cell *matCellDef="let sub">
            <img *ngIf="sub.imageIconUrl" [src]="sub.imageIconUrl" class="subcategory-icon" alt="icono" />
            <mat-icon *ngIf="!sub.imageIconUrl">image_not_supported</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let sub">{{ sub.subcategoryName }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let sub">
            <mat-slide-toggle
              [checked]="sub.active"
              (change)="toggleSubcategory(sub, $event.checked)">
            </mat-slide-toggle>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let sub">
            <button mat-icon-button matTooltip="Editar subcategoría"
                    (click)="openSubcategoryDialog(category, sub)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="primary" matTooltip="Editar formulario"
                    (click)="openFormBuilder(sub)">
              <mat-icon>dynamic_form</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <ng-template #noSubcategories>
        <p class="empty-message">Esta categoría aún no tiene subcategorías.</p>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>

  <p class="empty-message" *ngIf="!categories.length">No hay categorías registradas.</p>
</div>
